import React from 'react';

import styles from './styles.module.scss';

type SpinnerSize = 'extraSmall' | 'small' | 'medium' | 'large';

const sizeMap: Record<SpinnerSize, number> = {
  extraSmall: 12,
  small: 20,
  medium: 24,
  large: 30,
};

export interface SpinnerProps {
  className?: string;
  size?: SpinnerSize;
  color?: string;
}

export const Spinner = ({ size = 'medium', color, className = '' }: SpinnerProps) => {
  const spinnerStyle: React.CSSProperties = {
    width: sizeMap[size],
    height: sizeMap[size],
  };

  if (color) {
    spinnerStyle.borderLeftColor = color;
  }

  return <div className={`${styles.spinner} ${className}`} style={spinnerStyle} />;
};
